import { fullDistTree } from '@/utils/api'

/**
 * 计时器类
 */
export class AdTimer {
  expiredTime = null
  constructor(tms) {
    if (tms !== null && tms !== undefined) {
      this.reset(tms)
    }
  }
  reset(tms) {
    this.expiredTime = Date.now() + tms
  }
  isExpired() {
    if (this.expiredTime === undefined || this.expiredTime === null) {
      return true
    }
    return Date.now() >= this.expiredTime
  }
}

export class LocalCache {
  key2value = new Map()
  key2timeouter = new Map()
  _tms = 24 * 3.6e6 // 缓存有效期,默认一天(24小时)

  constructor(tms) {
    if (tms !== undefined) {
      this._tms = tms
    }
  }
  // 更新缓存值
  set(k, newValue) {
    this.key2value.set(k, newValue)
    this.key2timeouter.set(k, new AdTimer(this._tms))
  }

  async get(key, loadFn) {
    if (this.key2value.has(key)) {
      const timeouter = this.key2timeouter.get(key)
      //如果未设置计时器或者计时器在有效期内，则使用缓存中的数据
      if (!timeouter || !timeouter.isExpired()) {
        return this.key2value.get(key)
      }
    }
    return await loadFn(key)
  }
}

export default {
  _distCode2name: new LocalCache(),
  setCodeName(code, name) {
    this._distCode2name.set(code + '', name)
  },
  async getName(districtCode) {
    const dicCode = String(districtCode)
    return await this._distCode2name.get(dicCode, async () => {
      const res = await fullDistTree()
      let rv
      if (res && res.code === 0 && res.data) {
        const pros = res.data[0].children
        pros.forEach(p => {
          if (p.children) {
            p.children.forEach(c => {
              if (c.dicCode === dicCode) rv = c.districtValue
              this.setCodeName(c.dicCode, c.districtValue)
            })
          }
        })
      }
      return rv
    })
  }
}
